var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"10","md":"4","lg":"4"}},[_c('FormularioAtraparPokemon')],1),_c('b-col',{attrs:{"sm":"12","md":"8","lg":"8"}},[_c('CardPokemon',{attrs:{"array":_vm.pokemonsAtrapados}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }